import React from 'react';

import { Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { Button, ClearVerifyLogo, Modal } from 'src/components/common';
import { ModalId } from 'src/constants/modals';
import { useModal } from 'src/hooks/shared';

export const UserEmailConfirmRequestFulfilledModal: React.FC = () => {
  const navigate = useNavigate();

  const { closeModal, isOpen } = useModal(ModalId.UserEmailConfirmRequestFulfilled);

  const timerId = React.useRef<number | null>(null);

  React.useEffect(() => {
    if (isOpen && !timerId.current) {
      timerId.current = window.setTimeout(() => {
        navigate(appRoutes.auth.logout);
      }, 3000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  const onCloseModal = React.useCallback(() => {
    navigate(appRoutes.auth.logout);
    closeModal();
  }, [closeModal, navigate]);

  return (
    <Modal
      dialogProps={{
        onClose: onCloseModal,
        open: isOpen,
      }}
      maxWidth={400}
    >
      <Grid container>
        <Grid size={{ xs: 12 }} mb={1}>
          <ClearVerifyLogo />
        </Grid>
        <Grid size={{ xs: 12 }} mb={1}>
          <Typography variant="h5">Email successfully changed</Typography>
        </Grid>
        <Grid size={{ xs: 12 }} mb={4}>
          <Typography variant="body2">You will be now redirected to the home page</Typography>
        </Grid>
        <Grid size={{ xs: 12 }} justifyContent="center">
          <Button variant="contained" onClick={onCloseModal}>
            Close
          </Button>
        </Grid>
      </Grid>
    </Modal>
  );
};
